import React from 'react';
import '../../css/components/OnlineStatusIndicator.css';

/**
 * Индикатор онлайн-статуса пользователя
 * @param {boolean} isOnline - Онлайн ли пользователь
 * @param {string|null} lastActivity - Время последней активности (ISO строка)
 * @param {string} size - Размер: 'sm' | 'md' | 'lg'
 * @param {boolean} showLabel - Показывать текстовую метку
 */
export default function OnlineStatusIndicator({ isOnline, lastActivity, size = 'md', showLabel = false }) {
    const formatLastActivity = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 1) return 'только что';
        if (diffMins < 60) return `${diffMins} мин. назад`;
        if (diffHours < 24) return `${diffHours} ч. назад`;
        if (diffDays < 7) return `${diffDays} дн. назад`;
        return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
    };

    const sizeClass = `online-status--${size}`;

    return (
        <div className={`online-status ${sizeClass}`}>
            <span className={`online-status-dot ${isOnline ? 'online' : 'offline'}`} />
            {showLabel && (
                <span className="online-status-label">
                    {isOnline ? 'Онлайн' : lastActivity ? `Был ${formatLastActivity(lastActivity)}` : 'Офлайн'}
                </span>
            )}
        </div>
    );
}
